<template>
    <div class="list_currb" >
        <div class="titleBiao"><span style="color:#c30d23;cursor:pointer;" @click="goback(1)">{{adds_str.package_name}}</span>  /课节</div>
        <div class="list_ke_wrap">
            <div class="top_list">
                <!-- <i class="backtop" @click="backtop"></i> -->
                <span>{{adds_str.package_name}}(共{{adds_str.lesson_num}}节课)</span>
            </div>
            <hr>
            <div class="tb_wrap">
                <el-table :data="addls" style="width: 100%;border: 1px solid #e6e6e6;" highlight-current-row @current-change="gonextpage" :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                    <el-table-column prop="number" align="center" label="编号" width="80"></el-table-column>
                    <el-table-column prop="name" align="center" label="名称"></el-table-column>
                    <el-table-column prop="updated_at" align="center" label="更新时间"></el-table-column>
                    <el-table-column label="操作" align="center" width="180">
                        <template slot-scope="scope">
                            <span class="edit_kj" @click="modify_kj($event,scope.$index)" style="margin-right:10px;"></span>
                            <span class="dele_kj"  @click="dele_kj($event,scope.$index)"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="add_kj" v-if="adds_str.lesson_num > addls.length" @click="set_table">+  新增课节</div>
            <div class="alertBox" v-if="show">
                <div class="alertMessage">
                    <div class="alrt_title clearfix">
                        <div class="name fl_left">{{title}}课节</div>
                        <!-- <div class="close fl_right" @click="qx_add_kj()"></div> -->
                    </div>
                    <div class="name_iptBox">
                        <label class="label_name">编号</label>
                        <input type="text" placeholder="编号" :disabled="disabled" class="input_type" v-model="number">
                    </div>
                    <div class="name_iptBox">
                        <label class="label_name">名称</label>
                        <input type="text" placeholder="名称" class="input_type" v-model="name">
                    </div>
                    <div class="name_iptBox clearfix" style="width:230px;">
                        <div class="fl_left alertBtn alertBd" @click="qd_add_kj(num)">确定</div>
                        <div class="fl_right alertBtn" @click="qx_add_kj()">取消</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
function sortId(a,b){
    return a.number-b.number
}
    export default{
        data(){
            return {
                disabled:false,
                kjhide:true,
                addls:[],
                show:false,
                course_id:'',   //舞种id
                package_id:'',   //期id
                package_len:'',    //课节名称
                name:'',
                num:0,
                show:false,
                title:'新增',
                number:'',
                table_id:'',
                adds_str:[],
            }
        },
        // props:['adds_str'],
        // mounted(){
        //   if (window.history && window.history.pushState) {
        //     history.pushState(null, null, document.URL);
        //     window.addEventListener('popstate', this.backtop, false);
        //   }
        // },
        methods:{
            goback(index){
                // if(index==1){
                //     this.$router.go(-1);
                // }
                // if(index==2){
                //     this.$router.go(-2);
                // }
                if(index==1){
                    // this.$router.go(-2);
                    // let luder=JSON.parse(localStorage.getItem("luder"));
                    this.$router.push({
                        path:'/manager/stu_class/class/singleLesson',
                        query:{
                            // cate_id:luder.cate_id,
                            // name:luder.cate_id
                        }
                    })
                }
                if(index==2){
                    // this.$router.go(-3);
                    this.$router.push({
                        path:'/manager/stu_class/class',
                    })
                }
            },
            backtop(e){
                e.stopPropagation();
                this.$emit('addkjs',this.addls.length);
                this.kjhide = false;
                /*this.$router.replace({
                    path:'/manager/addCategory/centersCon/singleLesson'
                })*/
            },
            
            set_table(){
                this.num = 0
                this.show = true;
            },

            gonextpage(item){
                const _this = this;
                // localStorage.setItem('table_list',JSON.stringify(this.adds_str))
                var list = {
                    title:item.number,
                    name:item.name,
                    table_id:item.id,
                    course_id:_this.course_id,
                    package:this.package_len,
                    package_id:_this.adds_str.package_id,
                    package_name:_this.adds_str.package_name,
                }
                sessionStorage.setItem('lesson',JSON.stringify(list))
                // const num=_this.$md5("'"+val.number+"'")
                // const id=_this.$md5("'"+val.id+"'")
                // const cor=_this.$md5("'"+_this.cor+"'")
                // const pack=_this.$md5("'"+this.cor+"'")
                // const pocId=_this.$md5("'"+_this.addless.package_id+"'")

                _this.$router.push({
                    path:'/manager/stu_class/class/singleLesson/addKj/makTep',
                    name:'makTep',
                    query:{
                        title:item.number,
                        table_id:item.id,
                        course_id:_this.course_id,
                        package_id:_this.adds_str.package_id
                    }
                })
            },

            modify_kj(e,i){
                e.stopPropagation();
                this.title = "编辑"
                this.num = 1
                this.disabled = true
                this.number = this.addls[i].number;
                this.name=this.addls[i].name;
                this.table_id=this.addls[i].id;
                this.show = true
            },

            qd_add_kj(num){
                const _this = this;
                const NumReg = /^\+?[1-9][0-9]*$/;
                if(_this.number === ""){
                    _this.$message.error('请输入课节编号')
                }
                else if(!NumReg.test(_this.number)){
                    _this.$message.error('请输入正确的课节编号')
                }
                else if(_this.name == ""){
                    _this.$message.error('课节名称不可为空')
                }
                else{
                    if(_this.num == 0){
                        _this.$axios.post('addissuetable',{
                            issue_id:this.adds_str.package_id,
                            name:this.name,
                            number:this.number
                        }).then((res)=>{
                            if(res.data.code == 200){
                                _this.$message.success('添加成功')
                                _this.lesson(_this.adds_str.package_id)
                                _this.qx_add_kj()
                            }
                            else{
                                _this.$message.error(res.data.message)
                            }
                        }).catch( error =>{
                            console.log(error)
                        })
                    }
                    else{
                        _this.$axios.post('editissuetable',{
                            table_id:_this.table_id,
                            name:_this.name,
                            number:_this.number
                        }).then((res)=>{
                            if(res.data.code == 200){
                                _this.$message.success('修改成功')
                                _this.lesson(_this.adds_str.package_id)
                                _this.qx_add_kj()
                            }
                            else{
                                _this.$message.error(res.data.message)
                            }
                        }).catch( error =>{
                            console.log(error)
                        })
                    }
                }
            },

            
            qx_add_kj(){
                this.number = ""
                this.name = ""
                this.disabled = false
                this.show = false;
            },
            dele_kj(e,i){
                e.stopPropagation();
                const _this=this;
                this.$confirm('此操作将永久删除该节课所有内容, 是否继续?', '提示', {
                    onfirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$axios.post('deleteissuetable',{
                        // package_id:this.adds_str.package_id,
                        table_id:this.addls[i].id
                    }).then((res)=>{
                        if(res.data.code == 200){
                            _this.$message.success('删除成功');
                            _this.addls.splice(i,1)
                        }
                        else{
                            _this.$message.error(res.data.message)
                        }
                    }).catch( error =>{
                        console.log(error)
                    })
                }).catch(() => {         
                });     
            },
            lesson(item){
                let _this = this;
                _this.$axios.post('getIssuetablelist',{issue_id:item}).then((res)=>{
                    if(res.data.code == 200){
                        _this.addls = res.data.data;
                    }
                    else{
                        _this.$message.error(res.data.message)
                    }
                }).catch( error =>{
                    console.log(error)
                })
            },
            showCon(){
                const _this = this;
                _this.adds_str = JSON.parse(localStorage.getItem('table_list'))
                // _this.adds_str.package_id = adds_str.package_id;
                // _this.adds_str.package_name = adds_str.package_name
                // _this.adds_str.lesson_num = adds_str.lesson_num
                // _this.adds_str.course_id = adds_str.course_id
                // // _this.addless.num = adds_str.num;
                // _this.course_id = adds_str.course_id;
                // _this.package_len = adds_str.num;
                _this.lesson(_this.adds_str.package_id)
            }
        },
        created(){
            const _this = this;
            _this.showCon()            
            // console.log(this.ad/dless)
        },
        /*destroyed(){
          window.removeEventListener('popstate', this.backtop, false);
        },*/
        watch:{
        }
    };
</script>
<style scoped>
.titleBiao{
    line-height: 68px;
    color: #303030;
    font-size: 18px;
}
.list_ke_wrap{width: 100%;background: #fff;padding-bottom: 20px;min-height: 785px;position: relative;box-sizing: border-box;}
.top_list{border-bottom: 1px solid #fff;padding:0 24px;box-sizing: border-box;height: 64px;line-height: 64px;color:#333;}
.backtop{background: url(../../../static/imgs/back_purple.png) 0 center no-repeat;width: 27px;height: 27px;vertical-align: middle;display: inline-block;background-size: 100%;margin-right: 12px;cursor: pointer;}
.alertBox{position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 999;background: rgba(0,0,0,0.3);padding-top: 8%;}
.alertMessage{width: 500px;min-height: 300px;margin: 0 auto;background: #fff;border-radius: 4px;}
.alrt_title{background: #f4f5f9;padding: 0 10px;border-radius: 4px 4px 0 0 ;line-height: 43px;}
.close{background: url(../../../static/imgs/delect_qx.png) center center no-repeat;width: 20px;height: 44px;background-size: contain;cursor: pointer;}
.name_iptBox{border-radius: 4px;height: 38px;line-height: 38px;box-sizing: border-box;width: 320px;margin: 20px auto 0;}
.input_type{border:1px solid #e6e6e6;padding-left: 10px;background: #fff;width: 240px;height: 36px;border-radius: 4px; }
.label_name{margin-right: 20px;}
.alertBtn{width: 106px;height: 36px;box-sizing: border-box;text-align: center;line-height: 36px;border:1px solid #ddd;color:#333;border-radius: 4px;}
.alertBd{background: #c30d23;color: #fff;border-color: #c30d23;}
.add_kj{width: 148px;height: 36px;line-height: 36px;border: dashed 2px #d9dadc;font-size: 14px;color: #999;margin: 23px auto 0;text-align: center;cursor: pointer;position: relative;}
.edit_kj,.dele_kj{width: 16px;height: 18px;background: url(../../../static/imgs/icon_write_gray.png) 0 0 no-repeat;display: inline-block;background-size: 100%;position: relative;cursor: pointer;}
.dele_kj{background-image: url(../../../static/imgs/icon_delete_gray.png);}
.dele_kj:hover{background-image: url(../../../static/imgs/icon_delete_red.png);}
.edit_kj:hover{background-image: url(../../../static/imgs/icon_write_red.png);}
.tb_wrap{margin:  0 20px;padding-top: 24px;}
hr{height: 10px;background: #f6f6f6;border :none;}
</style>


// WEBPACK FOOTER //
// src/components/index/addKj.vue